import * as React from 'react'

import { SVGResponsive } from './common'

function Subsidized() {
  return (
    <SVGResponsive height={24} width={24}>
      <path
        fill="currentColor"
        d="M1 9.2563v-1c-.5523 0-1 .4477-1 1h1zm.0075 0v1a1 1 0 00.64-.2317l-.64-.7683zm9.0725-7.557L9.44.931l.64.7684zm3.84 0l.6401-.7684-.6401.7684zm9.0725 7.557l-.64.7683a.9998.9998 0 00.64.2317v-1zm.0075 0h1c0-.5523-.4477-1-1-1v1zm-1 .0062v11.7376h2V9.2625h-2zm0 11.7376c0 .5523-.4477 1-1 1v2c1.6569 0 3-1.3431 3-3h-2zm-1 1H3v2h18v-2zm-18 0c-.5523 0-1-.4477-1-1H0c0 1.6568 1.3432 3 3 3v-2zm-1-1V9.2625H0v11.7376h2zM2 9.2625v-.0062H0v.0062h2zm-1 .9938h.0075v-2H1v2zm.6475-.2317l9.0725-7.557L9.44.931.3674 8.488l1.28 1.5367zm9.0725-7.557c.7415-.6176 1.8185-.6176 2.56 0L14.5601.931c-1.4832-1.2354-3.637-1.2354-5.1202 0L10.72 2.4677zm2.56 0l9.0725 7.557 1.28-1.5367L14.5601.931 13.28 2.4677zm9.7125 7.7887H23v-2h-.0075v2zm-.9925-1v.0062h2v-.0062h-2z"
      />
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M23 10.5l-9.3894 5.9751a3.0001 3.0001 0 01-3.2212 0L1 10.5"
      />
      <path
        stroke="currentColor"
        strokeWidth="2"
        d="M7.6312 7.8724c1.5453-1.6255 3.0906-.7155 4.3268.585.9325-1.0472 3.5542-2.373 4.6359-.2599 1.0817 2.1132.1545 4.5515-4.6359 7.8025-4.6359-3.4136-5.872-6.502-4.3268-8.1276z"
      />
    </SVGResponsive>
  )
}

export default React.memo(Subsidized)
